function getChakraCustomCSS() {
  return {
    '.chakra-modal__content': {
      // height: '100%',
    },
  }
}

export default getChakraCustomCSS
